<template>
<div class="chapter">
<div class="inner_page">
<p class="p6"><span class="t7">By</span> K<span class="t8">ATE</span> M<span class="t8">C</span>M<span class="t8">URRAY</span></p>
<p class="p0"><span class="t7">Blind Items</span></p>
<p class="p0"><span class="t7">Four Corners</span></p>
<p class="p0"><span class="t7">Kindling Fire with Snow</span></p>
<p class="p0"><span class="t7">Playing Ball (Anthology)</span></p>
<p class="p0"><span class="t7">The Stars that Tremble • The Silence of the Stars</span></p>
<p class="p0"><span class="t7">A Walk in the Dark</span></p>
<p class="p0"><span class="t7">What There Is</span></p>
<p class="p0"><span class="t7">When the Planets Align</span></p>
<p class="p7"><span class="t7">Published by</span> D<span class="t8">REAMSPINNER</span> P<span class="t8">RESS</span></p>
<p class="p0"><span class="t7">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?29578bae